import _ from 'lodash';
import React, { useMemo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';

import CustomTable from './custom-table';
import { GET_PARTICIPANT_PATHS } from '../../graphql';

import {
  Container,
  ContainerDropwdown,
  Dropdown,
  Loader,
  Message,
  Title,
} from './styles';

const ParticipantPaths = (props) => {
  const { projectId, segmentId } = props;

  const [selectedTask, setTask] = useState(null);

  const {
    loading,
    data = {},
    errors,
  } = useQuery(GET_PARTICIPANT_PATHS, {
    variables: { projectId, segmentId },
  });

  const { analytics = {} } = data;
  const { treeTestParticipantPaths = [] } = analytics;

  useEffect(() => {
    if (treeTestParticipantPaths) {
      setTask(treeTestParticipantPaths[0]);
    }
  }, [treeTestParticipantPaths]);

  const options = useMemo(() => (
    _.map(treeTestParticipantPaths, (item) => ({
      key: item.id,
      value: item.id,
      text: item.title,
    }))
  ), [treeTestParticipantPaths]);

  if (errors) {
    return (
      <Message>
        Error while fetching analytics.
      </Message>
    );
  }

  const handleChange = (e, { value }) => {
    const task = _.find(treeTestParticipantPaths, { id: value });
    setTask(task);
  };

  return (
    <Container>
      <Title as="h3">Participant Paths</Title>
      <ContainerDropwdown>
        <Dropdown
          value={selectedTask?.id}
          fluid
          selection
          onChange={handleChange}
          options={options}
        />
      </ContainerDropwdown>
      {(loading) && (
        <Loader data-loader="participants-loader" />
      )}
      {!loading && selectedTask?.testers && (
        <CustomTable branches={selectedTask?.testers} />
      )}
    </Container>
  );
};

ParticipantPaths.propTypes = {
  projectId: PropTypes.string.isRequired,
  segmentId: PropTypes.string,
};

ParticipantPaths.defaultProps = {
  segmentId: undefined,
};
export default ParticipantPaths;
